import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fly-admin-legacy-app',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {}
